import { useState } from "react";

function AssetsPage() {

const [assetType,setAssetType] = useState("Bank")
const [accountName,setAccountName] = useState("")
const [username,setUsername] = useState("")
const [instructions,setInstructions] = useState("")

const handleSubmit = async (e) => {
e.preventDefault()

const res = await fetch("https://final-trace.onrender.com/api/assets/add",{
method:"POST",
headers:{
"Content-Type":"application/json"
},
body:JSON.stringify({
assetType,
accountName,
username,
instructions
})
})

const data = await res.json()
alert(data.message)

setAccountName("")
setUsername("")
setInstructions("")
}

return(

<div style={{
display:"flex",
justifyContent:"center",
alignItems:"center",
minHeight:"100vh",
background:"linear-gradient(135deg,#1e3c72,#2a5298)"
}}>

<div style={{
background:"white",
padding:"40px",
borderRadius:"12px",
width:"400px",
boxShadow:"0 8px 20px rgba(0,0,0,0.2)"
}}>

<h2 style={{textAlign:"center",marginBottom:"20px"}}>
Add Digital Asset
</h2>

<form onSubmit={handleSubmit}>

<select
value={assetType}
onChange={(e)=>setAssetType(e.target.value)}
style={{
width:"100%",
padding:"10px",
marginBottom:"12px",
borderRadius:"6px",
border:"1px solid #ccc"
}}
>
<option>Bank</option>
<option>LIC</option>
<option>Social Media</option>
<option>Crypto Wallet</option>
</select>

<input
placeholder="Account Name"
value={accountName}
onChange={(e)=>setAccountName(e.target.value)}
style={{
width:"100%",
padding:"10px",
marginBottom:"12px",
borderRadius:"6px",
border:"1px solid #ccc"
}}
/>

<input
placeholder="Username / Account ID"
value={username}
onChange={(e)=>setUsername(e.target.value)}
style={{
width:"100%",
padding:"10px",
marginBottom:"12px",
borderRadius:"6px",
border:"1px solid #ccc"
}}
/>

<textarea
placeholder="Instructions for executor"
value={instructions}
onChange={(e)=>setInstructions(e.target.value)}
rows="4"
style={{
width:"100%",
padding:"10px",
marginBottom:"12px",
borderRadius:"6px",
border:"1px solid #ccc"
}}
/>

<button
type="submit"
style={{
width:"100%",
padding:"12px",
background:"#2a5298",
color:"white",
border:"none",
borderRadius:"6px",
cursor:"pointer",
fontWeight:"bold"
}}
>
Save Asset
</button>

</form>

</div>

</div>

)

}

export default AssetsPage